<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Listado de Movimientos

            </legend>
          </div>
          <div>
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6" v-if="this.rol == 1">
                <label>Filtra por dependencia:</label>
                <el-select clearable filterable class="select-default" placeholder="Seleccione una opción" v-model="filtro" @change="getmovimientos" :disabled="isLoading">
                  <el-option v-for="option in dependencias" class="select-default" :value="option.id" :label="option.valor" :key="option.label"></el-option>
                </el-select>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-sm-6 col-md-6 col-lg-6">
                <b-button @click.prevent="getmovimientos()" v-b-popover.hover.top="'Refrescar'" class="btn-s edit mr-2" variant="primary">
                  <i class="fas fa-undo-alt"></i>
                </b-button>
              </div> -->


              <div class="col-6 pull-right">
                <label>Buscar:</label>
                <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>

              </div>
              <div class="col-6  d-flex align-items-end justify-content-end">
                <export-excel class="btn btn-wd btn-success pull-right" :data="lista_movimientos2" :meta="meta" :fields="lista_campos" worksheet="Movimientos" name="Movimientos.xls" v-if="lista_movimientos2.length > 0">
                  <span class="btn-label">
                    <i class="fa fa-file-excel"></i>
                  </span>
                  Descargar
                </export-excel>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <!-- item-key="id" -->
                <v-app>
                  <v-data-table :headers="headers" :search="filter" :custom-filter="customFilter" :items="lista_movimientos" single-select item-key="id" show-expand :expanded.sync="expanded" @click:row="rowClick">
                    <!-- <v-data-table :headers="headers" :items="lista_movimientos"  :single-expand="true" :expanded.sync="expanded" :show-expand="true" class=""> -->
                    <template v-slot:item.acciones="{ item }">
                      <div class="d-flex justify-content-center">
                        <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success" :disabled="edit_item != null">
                          <i class="fas fa-pencil-alt"></i></b-button>
                      </div>
                    </template>
                    <template v-slot:item.tipo_mov="{ item }">
                      <div class="alert  mb-0 p-1 alert-info">
                        <b> {{ setMovimiento(item.tipo_mov) }}</b>
                      </div>
                    </template>
                    <template v-slot:item.rfc="{ item }">
                      <div>{{ item.servidor.rfc }} </div>
                    </template>
                    <template v-slot:item.nombres="{ item }">
                      <div>{{ item.servidor.nombres + ' ' + item.servidor.primer_apellido + ' ' + item.servidor.segundo_apellido }} </div>
                    </template>
                    <template v-slot:item.area="{ item }">
                      <div>{{ item.encargo.area_adscripcion }}</div>
                    </template>
                    <template v-slot:item.inicia="{ item }">
                      <div>{{ item.inicia | dateFormat }}</div>
                    </template>
                    <template v-slot:item.termina="{ item }">
                      <div>{{ item.termina | dateFormat }}</div>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length">

                        <v-card :key="item.id" class="p-1 m-0" flat>
                          <v-card-text class="p-1">
                            <h3 class="text-h5 mb-2 mt-2">
                              {{ item.servidor.nombres + ' ' + item.servidor.primer_apellido + ' ' + item.servidor.segundo_apellido }}
                            </h3>
                            <div class="blue--text mb-2">
                              {{ item.servidor.rfc }}
                            </div>
                          </v-card-text>
                          <v-divider class="m-0 p-0 mb-2"></v-divider>

                          <v-row class="text-left m-0 pt-2 pb-2">
                            <v-col class=" m-0 p-1" tag="strong" cols="12"> Movimiento: </v-col>
                            <v-col cols="12" class="m-0 p-1 pb-3 font-weight-bold border-bottom">{{ setMovimiento(item.tipo_mov) }} {{ (item.tipo_mov == 2) ? '/ ' + item.tipo_baja : '' }}</v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2" v-if="item.origen">
                            <v-col class=" m-0 p-1" tag="strong" cols="12" v-if="item.origen"> Movimiento Origen / Cambio: </v-col>
                            <v-col cols="6" class="m-0 p-1 pb-3 border-bottom">
                              <v-row class="p-3">
                                <v-col cols="12" class="m-0 p-0">
                                  <strong class="pl-4 pr-1">RFC :</strong> {{ item.origen.rfc ? item.origen.rfc : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">CURP :</strong> {{ item.origen.curp ? item.origen.curp : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Correo electrónico laboral :</strong> {{ item.origen.correo_electronico_laboral ? item.origen.correo_electronico_laboral : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Nombre :</strong> {{ item.origen.nombres + ' ' + item.origen.primer_apellido + ' ' + item.origen.segundo_apellido }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Dependencia :</strong> {{ item.origen.dependencia ? getDependencias(item.origen.dependencia) : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Cargo :</strong> {{ item.origen.cargo ? item.origen.cargo : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0" v-if="item.origen.honorarios">
                                  <strong class="pl-4 pr-1">Honorarios :</strong> {{ item.origen.honorarios == 2 ? 'No' : 'Si' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0" v-if="item.origen.contratado_honorarios">
                                  <strong class="pl-4 pr-1">Honorarios :</strong> {{ item.origen.contratado_honorarios == 2 ? 'No' : 'Si' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Nivel :</strong> {{ item.origen.nivel ? item.origen.nivel : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Área :</strong> {{ item.origen.area ? item.origen.area : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Titular :</strong> {{ item.origen.titular ? (item.origen.titular == 2 ? 'No' : 'Si') : 'No' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Fecha posesion :</strong> {{ item.origen.fecha_posesion ? item.origen.fecha_posesion : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Fecha termino :</strong> {{ item.origen.fecha_termino ? item.origen.fecha_termino : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Simplificada :</strong> {{ item.origen.simplificada == '0' || item.origen.simplificada == 0 ? 'No' : 'Si' }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="6" class="m-0 p-1 pb-3 border-bottom border-left">
                              <v-row class="p-3">
                                <v-col cols="12" class="m-0 p-0">
                                  <strong class="pl-4 pr-1">RFC :</strong> {{ item.cambio.rfc ? item.cambio.rfc : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">CURP :</strong> {{ item.cambio.curp ? item.cambio.curp : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Correo electrónico laboral :</strong> {{ item.cambio.correo_electronico_laboral ? item.cambio.correo_electronico_laboral : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Nombre :</strong> {{ item.cambio.nombres + ' ' + item.cambio.primer_apellido + ' ' + item.cambio.segundo_apellido }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Dependencia :</strong> {{ item.cambio.dependencia ? getDependencias(item.cambio.dependencia) : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Cargo :</strong> {{ item.cambio.cargo ? item.cambio.cargo : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0" v-if="item.cambio.honorarios">
                                  <strong class="pl-4 pr-1">Honorarios :</strong> {{ item.cambio.honorarios == 2 ? 'No' : 'Si' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0" v-if="item.cambio.contratado_honorarios">
                                  <strong class="pl-4 pr-1">Honorarios :</strong> {{ item.cambio.contratado_honorarios == 2 ? 'No' : 'Si' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Nivel :</strong> {{ item.cambio.nivel ? item.cambio.nivel : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Área :</strong> {{ item.cambio.area ? item.cambio.area : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Titular :</strong> {{ item.cambio.titular ? (item.cambio.titular == 2 ? 'No' : 'Si') : 'No' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Fecha posesion :</strong> {{ item.cambio.fecha_posesion ? item.cambio.fecha_posesion : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Fecha termino :</strong> {{ item.cambio.fecha_termino ? item.cambio.fecha_termino : '' }}
                                </v-col>
                                <v-col cols="12" class=" m-0 p-0">
                                  <strong class="pl-4 pr-1">Simplificada :</strong> {{ item.cambio.simplificada == '0' || item.cambio.simplificada == 0 ? 'No' : 'Si' }}
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2">
                            <v-col class=" m-0 p-1" tag="strong" cols="12"> Observaciones: </v-col>
                            <v-col cols="12" class="m-0 p-1 pb-3 border-bottom">{{ item.motivo ? item.motivo : 'Sin observaciones.' }}</v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2" v-if="item.usuario">
                            <v-col class=" m-0 p-1 " tag="strong" cols="12"> Datos del creador del movimiento: </v-col>
                            <v-col cols="12" class="m-0 p-1 ">{{ item.usuario.Nombre + ' ' + item.usuario.Paterno + ' ' + item.usuario.Materno }}</v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador email: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 ">{{ item.usuario.User }} </v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador dependencia: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 pb-3">{{ getDependencias(item.usuario.ID_Dependencia) }} </v-col>
                          </v-row>
                          <v-row class="text-left m-0 pt-2 pb-2" v-if="item.aprobacion">
                            <v-col class=" m-0 p-1 " tag="strong" cols="12"> Datos de aprobación: </v-col>
                            <v-col cols="12" class="m-0 p-1 ">{{ item.aprobacion.Nombre + ' ' + item.aprobacion.Paterno + ' ' + item.aprobacion.Materno }}</v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador email: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 ">{{ item.aprobacion.User }} </v-col>
                            <!-- <v-col class=" m-0 p-1 " tag="strong" cols="12"> Creador dependencia: </v-col> -->
                            <v-col cols="12" class="m-0 p-1 pb-3">{{ getDependencias(item.aprobacion.ID_Dependencia) }} </v-col>
                          </v-row>
                        </v-card>
                      </td>
                    </template>

                  </v-data-table>
                </v-app>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import excel from 'vue-excel-export'
import Vue from 'vue'
import moment from 'moment'
import {
  Select,
  Option,
  DatePicker
} from 'element-ui'

import {
  mapFields
} from 'vee-validate'

import Domicilio from '../Domicilio.vue'

Vue.use(Select)
Vue.use(Option)
Vue.use(excel)

export default {
  components: {
    [DatePicker.name]: DatePicker
  },
  props: ['data'],
  data () {
    return {
      expanded: [],
      filtro: null,
      filter: null,
      isLoading: false,
      currentPage: 1,
      perPage: 50,
      rol: '',
      rows: null,
      id: 1,
      // dependencias: null,
      item_usuarios: {},
      lista_movimientos: [],
      lista_movimientos2: [],
      cat_movimientos: [],
      headers: [{
        text: '',
        value: 'data-table-expand'
      },
      {
        text: 'Tipo movimiento',
        value: 'tipo_mov',
        align: 'center'
      },
      {
        text: 'RFC',
        value: 'rfc',
        align: 'center'
      }, {
        text: 'Nombre',
        value: 'nombres',
        align: 'left'
      },
      /* {
        text: 'Motivo',
        value: 'motivo',
        align: 'left',
      },  */
      {
        text: 'Inicio',
        value: 'inicia',
        align: 'center'
      }, , {
        text: 'Termino',
        value: 'termina',
        align: 'center'
      }

      ],
      meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      lista_campos: {
        'Nombres': 'nombres',
        'RFC': 'rfc',
        'CURP': 'curp',
        'Tipo Movimiento': 'tipo_movimiento',
        'Inicia': 'inicia',
        'Termina': 'termina',
        'Origen': 'origen',
        'Cambio': 'cambio',
        'Observaciones': 'observaciones',
        'Creador': 'creador',
        'Correo Creador': 'creador_mail',
        'Dependencia Creador': 'creador_dependencia',
        'Aprobación': 'aprobacion',
        'Correo Aprobación': 'aprobacion_mail',
        'Dependencia Aprobación': 'aprobacion_dependencia'
      }
    }
  },
  computed: {
    to () {
      let highBound = this.from + this.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.perPage * (this.currentPage - 1)
    },
    total () {
      // console.log(this.lista_movimientos.length);
      this.rows = this.lista_movimientos.length

      return this.lista_movimientos.length
    },
    fullName: {
      get () {
        return `${this.item_usuarios.nombres} ${this.item_usuarios.primer_apellido
          } ${this.item_usuarios.segundo_apellido}`
      },
      set (newValue) {
        const m = newValue.match(/(\S*)\s+(.*)/)

        this.nombres = m[1]
        this.primer_apellido = m[2]
        this.segundo_apellido = m[3]
      }
    }
  },
  methods: {

    customFilter (value, search, item) {
      search = search.toString().toLowerCase()
      var filter = this.flat(item, {})

      return Object.values(filter).some(v => {
        // console.log(v);
        return v && v.toString().toLowerCase().includes(search)
      })
    },
    flat (obj, out) {
      if (obj) {
        Object.keys(obj).forEach(key => {
          if (typeof obj[key] === 'object') {
            out = this.flat(obj[key], out) // recursively call for nesteds
          } else {
            out[key] = obj[key] // direct assign for values
          }
        })
      }
      return out
    },
    rowClick (item, row) {
      const indexRow = item.index
      const indexExpanded = this.expanded.findIndex(i => i === item)
      // console.log(indexExpanded);
      if (indexExpanded > -1) {
        this.expanded = []
        row.select(false)
        // console.log('splice', this.expanded);
      } else {
        this.expanded = [item]
        row.select(true)
        // console.log('push', this.expanded);
      }
    },
    initItem () {
      this.item_usuarios = {
        acciones: '',
        nombres: '',
        Paterno: '',
        Materno: '',
        User: '',
        Password: ''
      }
    },

    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getDependencias (index) {
      var resp = ' '
      if (this.dependencias) {
        this.dependencias.forEach(function (item) {
          if (item.id == index) {
            resp = item.valor
            return resp
          }
        })
      }
      return resp
    },

    getmovimientos () {
      this.lista_movimientos2 = []
      var params = {
        params: {
          ente_publico_id: this.filtro
        }
      }
      this.isLoading = true
      this.$http.get('movimientos', params).then(
        response => {
          this.lista_movimientos = response.data.movimientos
          this.lista_movimientos.forEach((value, key) => {
            this.isLoading = false
            let aprobacion = {
              Nombre: '',
              Paterno: '',
              Materno: '',
              User: '',
              ID_Dependencia: ''
            }
            let usuario = {
              Nombre: '',
              Paterno: '',
              Materno: '',
              User: '',
              ID_Dependencia: ''
            }

            if (value.aprobacion) {
              aprobacion = value.aprobacion
            }
            if (value.usuario) {
              usuario = value.usuario
            }

            this.lista_movimientos2.push({
              'nombres': value.servidor.nombres + ' ' + value.servidor.primer_apellido + ' ' + value.servidor.segundo_apellido,
              'rfc': value.servidor.rfc,
              'curp': value.servidor.curp,
              'tipo_movimiento': this.setMovimiento(value.tipo_mov),
              'inicia': value.inicia,
              'termina': value.termina,
              'origen': value.origen ? Object.values(value.origen).join(', ') : '',
              'cambio': value.cambio ? Object.values(value.cambio).join(', ') : '',
              'observaciones': value.motivo,
              'creador': usuario.Nombre + ' ' + usuario.Paterno + ' ' + usuario.Materno,
              'creador_mail': usuario.User,
              'creador_dependencia': this.getDependencias(usuario.ID_Dependencia),
              'aprobacion': aprobacion.Nombre + ' ' + aprobacion.Paterno + ' ' + aprobacion.Materno,
              'aprobacion_mail': aprobacion.User,
              'aprobacion_dependencia': this.getDependencias(aprobacion.ID_Dependencia)
            })
          })
        },
        error => {
          this.isLoading = false
          this.Err(error)
        }
      )
    },
    getCatMovimientos () {
      this.$http.get('cat_movimientos').then(
        response => {
          this.cat_movimientos = response.data.movimientos

          this.cat_movimientos.push({
            id: 10,
            tipo: 'Reactivación'
          })

          this.getmovimientos()
        },
        error => {
          this.Err(error)
        }
      )
    },
    setMovimiento (index) {
      var resp = ' '
      if (index) {
        if (this.cat_movimientos) {
          this.cat_movimientos.forEach(function (item) {
            if (item.id == index) {
              resp = item.tipo
              return resp
            }
          })
        }
      }
      return resp
    }
  },
  created () {
    this.initItem()
    this.filtro = this.getKey('ente_publico_id')

    this.rol = this.getKey('role')

    this.getCatMovimientos()

    // this.$http.get("cat_ente_publico").then(
    //   response => {
    //     this.dependencias = response.data.entes_publicos;
    //   },
    //   error => {
    //     this.Err(error);
    //   }
    // );
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>
<style>
.v-data-table>.v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 0px 0px 0px rgba(50, 50, 50, 0.15), inset 0px 0px 0px 1px rgba(50, 50, 50, 0.1);
  /* border: thin solid rgba(0, 0, 0, 0.12); */
}

.theme--light.v-divider {

  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

tr.v-data-table__selected {
  background: rgba(0, 0, 0, 0.05) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/ListaMovimientos.vue